import { IPListType, RawIPListType, Store, UserPod } from '../types';
import { ListIpsAction } from '../actions/listips';

export type State = {
  readonly ips: IPListType;
  readonly userPod: UserPod;
};

export const INITIAL_LIST_IPS_STATE: State = {
  ips: {
    aws: {
      cspmAccount: '',
      cloudTrail: '',
      s3Logs: '',
    },
    agent: [],
    mr: [],
    mdr: [],
    cloud: [],
    externalScans: [],
    integrations: [],
    ma: [],
  },
  userPod: {
    pod: '',
  },
};

export const AWNIPsFromAPI = (rawIPs: RawIPListType): IPListType => {
  return {
    aws: {
      cspmAccount: rawIPs?.AWS?.CSPMAccount,
      cloudTrail: rawIPs?.AWS?.CloudTrail,
      s3Logs: rawIPs?.AWS?.S3Logs,
    },
    agent: rawIPs.Agent,
    integrations: rawIPs.Integrations,
    externalScans: rawIPs.externalScans,
    cloud: rawIPs.Cloud,
    mdr: rawIPs.MDR,
    mr: rawIPs.MR,
    ma: rawIPs.MA,
  };
};

const listIpsReducer = (
  state: State = INITIAL_LIST_IPS_STATE,
  action: ListIpsAction,
): State => {
  switch (action.type) {
    case 'set_list_ips':
      return {
        ...state,
        ips: AWNIPsFromAPI(action.ips),
      };
    case 'set_user_pod':
      return {
        ...state,
        userPod: action.pod,
      };
    default:
      return state;
  }
};

export default listIpsReducer;

// ------------
// Selectors
// -------------

export const listIPsSelector = {
  getIPsList: (store: Store): IPListType => store.listIps.ips,
  hasFetchedAWNIPs: (store: Store): boolean =>
    store.listIps.ips !== INITIAL_LIST_IPS_STATE.ips,
  hasFetchedUserPod: (store: Store): boolean =>
    store.listIps.userPod !== INITIAL_LIST_IPS_STATE.userPod,
};
